import React from "react";
import HeroImage from '../image/hero.jpeg';
import { Link } from "react-router-dom";
function Hero() {
  return (
    <section className="text-gray-600 body-font mt-20">
      <div className="container mx-auto flex px-5 py-24 md:flex-row flex-col items-center">
        <div className="lg:flex-grow md:w-1/2 lg:pr-24 md:pr-16 flex flex-col md:items-start md:text-left mb-16 md:mb-0 items-center text-center">
          <h1 className="title-font sm:text-4xl text-3xl mb-4 font-medium text-gray-900">
            Anything
            <br className="hidden lg:inline-block" />
            but routine.
          </h1>
          <p className="mb-8 leading-relaxed">
            Effective, eco-friendly daily essentials made with clean
            ingredients.
          </p>
          <div className="flex justify-center">
            <Link to={'/product'} className="inline-flex text-white bg-purple-500 border-0 py-2 px-6 focus:outline-none hover:bg-purple-600 rounded text-lg rounded-full">
            Shop Now
            </Link>
          </div>
        </div>
        <div className="lg:max-w-lg lg:w-full md:w-1/2 w-5/6">
          <img
            className="object-cover object-center rounded"
            alt="hero"
            src={HeroImage}
          />
        </div>
      </div>
    </section>
  );
}

export default Hero;
